'use es6';

const getRoot = state => state.businessUnits;
export const getBusinessUnits = state => getRoot(state).businessUnits;
export const getBusinessUnitsRequestState = state => getRoot(state).requestState;